
<div>
  <b-card no-body no-header v-show="isShown">
    <b-card-header>
      <slot name="header" v-bind:item="item"></slot>
    </b-card-header>
    <b-card-body :class="cardBodyClasses" v-if="hasCardBody">
      <slot name="body" v-bind:item="item"></slot>
    </b-card-body>
    <slot name="nobody" v-bind:item="item"></slot>
    <b-card-footer v-if="hasCardFooter">
      <slot name="footer" v-bind:item="item"></slot>
    </b-card-footer>
  </b-card>
  <slot name="data_source"></slot>
  <slot name="dialog"></slot>
</div>
